import {
    Box,
    Flex,
    Image,
    Text
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useApp from '../context/AppContext'

function Player({data, sold=null, reserved=null}) {
    const {teams, players} = useApp()
    const navigate = useNavigate()
    const navToPlayer = (id) => navigate({
        pathname: '/playerProf',
        search: `?player=${id}`
    })

    useEffect(() => {

    })
    
    return (
        <Flex
            height={50}
            alignItems={'center'}
            px={5}
            flex={1}
            minH={50}
            cursor={"pointer"}
            border='1px' 
            borderColor='gray.700'
            borderRadius={10}
            justifyContent={'space-between'}
            transition={'all 0.25s ease'}
            _hover= {{
                color: 'cyan.500',
                borderColor: 'cyan.500',
                transform: 'translateY(-3px)'
            }}
            onClick={() => navToPlayer(`${data.pid}`)}
        >
            {data.mid}. {data.name}
            
            {sold?
                
                <Box>{teams.teams[sold.tid].name}: {sold.cost}</Box>
                :
                reserved?
                <Text>Reserved</Text>:
                <Text color={'gray.500'}>Not Sold Yet</Text>
            }

            
           
        </Flex>
    )
}

export default Player